import {createEntityAdapter, createSlice} from "@reduxjs/toolkit"
import {StoreState} from "store"
import {useSelector} from "react-redux"
import {BasicMenu} from "types/BasicMenu"
import {fetchBasicMenuList} from "./fetchBasicMenuList"
import {createBasicMenu} from "./createBasicMenu"
import {updateBasicMenu} from "./updateBasicMenu"
import {deleteBasicMenu} from "./deleteBasicMenu"

export const basicMenuAdapter = createEntityAdapter<BasicMenu>()

export interface StateProps {
    loading: boolean
}

const initialState = basicMenuAdapter.getInitialState<StateProps>({
    loading: true
})

const basicMenuSlice = createSlice({
    name: "basic-menu",
    initialState,
    reducers: {},
    extraReducers: builder => {
        // Получение списка дефолтных меню
        builder.addCase(fetchBasicMenuList.pending, state => {
            state.loading = true
        })
        builder.addCase(fetchBasicMenuList.fulfilled, (state, action) => {
            basicMenuAdapter.setMany(state, action.payload.menuList)
            state.loading = false
        })
        builder.addCase(fetchBasicMenuList.rejected, state => {
            state.loading = false
        })

        // Создание дефолтного меню
        builder.addCase(createBasicMenu.pending, state => {
            state.loading = true
        })
        builder.addCase(createBasicMenu.fulfilled, (state, action) => {
            basicMenuAdapter.setOne(state, action.payload.menu)
            state.loading = false
        })
        builder.addCase(createBasicMenu.rejected, state => {
            state.loading = false
        })

        // Обновление дефолтного меню
        builder.addCase(updateBasicMenu.pending, state => {
            state.loading = true
        })
        builder.addCase(updateBasicMenu.fulfilled, (state, action) => {
            basicMenuAdapter.setOne(state, action.payload.menu)
            state.loading = false
        })
        builder.addCase(updateBasicMenu.rejected, state => {
            state.loading = false
        })

        // Удаление дефолтного меню
        builder.addCase(deleteBasicMenu.pending, state => {
            state.loading = true
        })
        builder.addCase(deleteBasicMenu.fulfilled, (state, action) => {
            let key = action.meta
            basicMenuAdapter.removeOne(state, key.arg.id)
            state.loading = false
        })
        builder.addCase(deleteBasicMenu.rejected, state => {
            state.loading = false
        })
    }
})

export const {selectById, selectAll} = basicMenuAdapter.getSelectors<StoreState>(state => state.basicMenu)

// Загрузка
export const useLoadingBasicMenu = () => useSelector((state: StoreState) => state.basicMenu.loading)

// Вывод всех сотрудников
export const useSelectAllBasicMenu = () => useSelector(selectAll)

export default basicMenuSlice.reducer
